export default "__VITE_ASSET__ee04408f__"